import React from "react";
import {
  type CarouselApi,
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "ui";

import { type ExerciseImageCarouselProps } from "src/workouts/ExercisePreviewDialog";

export function ExerciseImageCarousel(props: ExerciseImageCarouselProps) {
  const [api, setApi] = React.useState<CarouselApi>();

  React.useEffect(() => {
    if (!api) {
      return;
    }

    if (api.selectedScrollSnap() !== props.activeIndex) {
      api.scrollTo(props.activeIndex);
    }
  }, [api, props.activeIndex]);

  React.useEffect(() => {
    if (!api) {
      return;
    }

    const carouselApi = api;

    function handleSelect() {
      props.onSelect(carouselApi.selectedScrollSnap());
    }

    carouselApi.on("select", handleSelect);

    return () => {
      carouselApi.off("select", handleSelect);
    };
  }, [api, props.onSelect]);

  return (
    <Carousel
      setApi={setApi}
      opts={{
        startIndex: props.activeIndex,
      }}
      className="mx-10"
    >
      <CarouselContent>
        {props.images.map((image) => {
          return (
            <CarouselItem key={image.url}>
              <div className="max-h-[60vh]">
                <img src={image.url} className="h-full w-full object-contain" />
              </div>
            </CarouselItem>
          );
        })}
      </CarouselContent>
      <CarouselPrevious />
      <CarouselNext />
    </Carousel>
  );
}
